import {QuoteWizardDefaultCustomViewController} from '../quoteWizardDefaultCustomView.controller';

export class ClaimTypesController extends QuoteWizardDefaultCustomViewController {
    public showRequiredError: boolean;
    public isValid: boolean;

    protected activate(): void {
        super.activate();
        this.isValid = this.areAnyChecked();
    }

    public goNext(): void {
        // if the user never interacted with a checkbox, that response is set to undefined - set all of those to false here so they all have a valid response
        // also per business rules, set over10k responses to false for any unchecked
        if (!this.stateService.viewModel.questionResponseGraph.anyPropertyClaimsInLastThreeYears.response) {
            this.stateService.viewModel.questionResponseGraph.anyPropertyClaimsInLastThreeYears.response = false;
            this.stateService.viewModel.questionResponseGraph.anyPropertyClaimsInLastThreeYearsOverTenThousand.response = false;
        }
        if (!this.stateService.viewModel.questionResponseGraph.anyLiabilityClaimsInLastThreeYears.response) {
            this.stateService.viewModel.questionResponseGraph.anyLiabilityClaimsInLastThreeYears.response = false;
            this.stateService.viewModel.questionResponseGraph.anyLiabilityClaimsInLastThreeYearsOverTenThousand.response = false;
        }
        if (!this.stateService.viewModel.questionResponseGraph.anyWorkCompClaimsInLastThreeYears.response) {
            this.stateService.viewModel.questionResponseGraph.anyWorkCompClaimsInLastThreeYears.response = false;
            this.stateService.viewModel.questionResponseGraph.anyWorkCompClaimsInLastThreeYearsOverTenThousand.response = false;
        }
        if (!this.stateService.viewModel.questionResponseGraph.anyOwnedAutoClaimsInLastThreeYears.response) {
            this.stateService.viewModel.questionResponseGraph.anyOwnedAutoClaimsInLastThreeYears.response = false;
            this.stateService.viewModel.questionResponseGraph.anyOwnedAutoClaimsInLastThreeYearsOverTenThousand.response = false;
        }
        if (!this.stateService.viewModel.questionResponseGraph.anyHiredNonOwnedAutoClaimsInLastThreeYears.response) {
            this.stateService.viewModel.questionResponseGraph.anyHiredNonOwnedAutoClaimsInLastThreeYears.response = false;
            this.stateService.viewModel.questionResponseGraph.anyHiredNonOwnedAutoClaimsInLastThreeYearsOverTenThousand.response = false;
        }
        if (!this.stateService.viewModel.questionResponseGraph.anyOtherClaimsInLastThreeYears.response) {
            this.stateService.viewModel.questionResponseGraph.anyOtherClaimsInLastThreeYears.response = false;
            this.stateService.viewModel.questionResponseGraph.anyOtherClaimsInLastThreeYearsOverTenThousand.response = false;
        }

        super.goNext();
    }

    public onCheckBoxChange(): void {
        this.isValid = this.areAnyChecked();
    }

    private areAnyChecked(): boolean {

        const isValid = (
            this.stateService.viewModel.questionResponseGraph.anyPropertyClaimsInLastThreeYears.response === true ||
            this.stateService.viewModel.questionResponseGraph.anyLiabilityClaimsInLastThreeYears.response === true ||
            this.stateService.viewModel.questionResponseGraph.anyWorkCompClaimsInLastThreeYears.response === true ||
            this.stateService.viewModel.questionResponseGraph.anyOwnedAutoClaimsInLastThreeYears.response === true ||
            this.stateService.viewModel.questionResponseGraph.anyHiredNonOwnedAutoClaimsInLastThreeYears.response === true ||
            this.stateService.viewModel.questionResponseGraph.anyOtherClaimsInLastThreeYears.response === true);

        return isValid;
    }
}